<div class="mt-5">
  <div class="header">
  <div class="row">
    <div class="col-md">
      <h3>{{'DASHBOARD.SMS' | translate}}</h3>
    </div>

    <div>

      <p-dropdown class="dv-dropdown" selectId="years" [options]="yearList" [(ngModel)]="selectedYear"
        [autoDisplayFirst]="false" placeholder="ปี" (onChange)="loadMonthlyDatasms()">
      </p-dropdown>

    </div>
  </div>
</div>
  </div>


<div class="box-parent scrollable" style="height: calc(100vh - 2.25rem - 150px);">
  <canvas id="sms-counter-bar-chart">{{ charts_sms_counter_bar_stackeds }}</canvas>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-sms/dashboard-sms.component.html